// extracted by mini-css-extract-plugin
export default {"tasks":"vM-z","task":"wM-z","svg":"xM-z","text":"yM-z"};